'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = salesPro;

var _immutable = require('immutable');

var _SalesPartnerActionTypes = require('../actionTypes/SalesPartnerActionTypes');

var initialState = new _immutable.Map({
  portalId: null,
  isProvisioned: false,
  error: null
});

function salesPro() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case _SalesPartnerActionTypes.PORTAL_SELECTED:
      return state.set('portalId', payload);

    case _SalesPartnerActionTypes.SALES_PARTNER_PROVISIONING_COMPLETED:
      return state.set('isProvisioned', true);

    case _SalesPartnerActionTypes.SALES_PARTNER_PROVISIONING_FAILED:
      return state.set('error', payload);

    default:
      return state;
  }
}
module.exports = exports['default'];